<template>
  <div id="app" :class="{beta: beta}">
    <div class="ui attached menu" v-if="!isLoginPage" id="top">
      <div class="ui container">
        <a class="item" v-for="view in views" :href="view.link">
          {{ view.label }}
        </a>
        <a class="right item" >
          Credits used: {{ creditsUsed }} / {{ creditsTotal }}
        </a>
        <a class="item" @click="logout">
          Logout
        </a>
      </div>
    </div>
    <alert-view
      v-bind:visible="this.showAlert"
      v-bind:header="alertHeader"
      v-bind:message="alertMessage"
      v-bind:update-visibility="updateAlertVisibility" />
    <router-view
      v-bind:show-product-tags="showProductTags"
      v-bind:update-credit="updateCredit"
      v-bind:should-disable-submit-btn="shouldDisableSubmitBtn"/>
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import Alert from './components/Alert'

export default {
  components: {
    'alert-view': Alert
  },
  mounted () {
    if (Cookies.get('token')) {
      axios.post(this.server + '/token', {
        token: Cookies.get('token')
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        this.views = response.data.views
        this.beta = response.data.beta
        this.showProductTags = response.data.showProductTags
      })
      .catch(error => {
        console.log(error)
        if (window.location.pathname !== '/login') window.location.href = '/login'
      })

      this.updateCredit()
    }
  },
  data: () => {
    return {
      server: process.env.SERVER || '',
      views: [],
      creditsLeft: '',
      creditsTotal: '',
      creditsUsed: '',
      showProductTags: false,
      beta: false,
      showAlert: false,
      alertHeader: '',
      alertMessage: ''
    }
  },
  computed: {
    isLoginPage () {
      return window.location.pathname === '/login'
    },
    shouldDisableSubmitBtn () {
      return this.creditsLeft <= 0
    }
  },
  methods: {
    logout () {
      Cookies.set('token', 'token', {expires: 0})
      window.location.href = '/login'
    },
    updateCredit () {
      const creditPath = this.server + '/credits?token=' + Cookies.get('token')
      axios.post(creditPath)
      .then(response => {
        this.$FullStory.event('updateCredit', {
          creditsLeft: response.data.creditsLeft,
          creditsTotal: response.data.creditsTotal,
          creditsUsed: this.creditsTotal - this.creditsLeft
        })
        this.creditsLeft = response.data.creditsLeft
        this.creditsTotal = response.data.creditsTotal
        this.creditsUsed = this.creditsTotal - this.creditsLeft
        if (this.creditsLeft <= 0) {
          this.alertHeader = 'Sorry!'
          this.alertMessage = 'You are out of credits, please email us at hello@hypotenuse.ai to top up your credits!'
          this.showAlert = true
        }
      })
    },
    updateAlertVisibility (newStatus) {
      this.showAlert = newStatus
    }
  },
  name: 'app'
}
</script>

<style>
:root {
  --color-primary: #ed2c4d;
  --color-primary-dark: #970d2b;
  --color-secondary: #2f03a0;
  --color-light-text: #ebebff;
}

body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
}
#app.beta:after{
  content: "beta";
  position: fixed;
  width: 80px;
  height: 25px;
  background: #F02849;
  top: 7px;
  left: -20px;
  text-align: center;
  font-size: 13px;
  font-family: sans-serif;
  text-transform: uppercase;
  font-weight: bold;
  color: #fff;
  line-height: 27px;
  transform:rotate(-45deg);
}

.right.item {
  border-right: 1px solid rgba(34,36,38,.1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue